import React from "react";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import {
  TextInput,
  AutocompleteInput,
  useGetList,
  required,
} from "react-admin";
import { CreateForm } from "../../../Layout/CreateForm";

const CreateGameForm = ({ handleClose }) => {
  const { data: buildingData, isPending: isBuildingPending } = useGetList(
    "VegasBuilding",
    {
      pagination: { page: 1, perPage: 10 },
      sort: { field: "createdAt", order: "ASC" },
    },
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );

  const gameTypeChoices = [
    { id: "VE", name: "VE" },
    { id: "TD", name: "TD" },
  ];

  return (
    <CreateForm
      title="Create New Game"
      handleClose={handleClose}
      resource="gameCatalogue"
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextInput
            id="name"
            name="name"
            label="Name"
            fullWidth
            validate={[required()]}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <AutocompleteInput
            source="type"
            label="Game Variant"
            choices={gameTypeChoices}
            fullWidth
            optionText="name"
            optionValue="id"
            validate={[required()]}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <AutocompleteInput
            source="building"
            label="Game Building"
            choices={
              isBuildingPending
                ? [{ id: "Null", name: "Loading" }]
                : buildingData
            }
            fullWidth
            optionText="name"
            optionValue="id"
            validate={[required()]}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <TextInput
            id="gameSequence"
            name="gameSequence"
            label="Game Sequence"
            fullWidth
            validate={[required()]}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^0-9]/g, "");
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <TextInput
            id="category"
            name="category"
            label="Category"
            fullWidth
            validate={[required()]}
          />
        </Grid>
        <Grid item xs={12}>
          <TextInput
            id="description"
            name="description"
            label="Description"
            fullWidth
          />
        </Grid>
      </Grid>
    </CreateForm>
  );
};

export const NewGameFormDialog = ({ open, handleClose }) => {
  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth="sm"
        open={open}
        onClose={handleClose}
        onClick={(evt) => evt.stopPropagation()}
      >
        <CreateGameForm handleClose={handleClose} />
      </Dialog>
    </React.Fragment>
  );
};
